export const ACTION_TYPE = {
  SET_MASTER_LANG: "SET_MASTER_LANG",
  SET_FACT_UPDATE: "SET_FACT_UPDATE",
};

export function setMasterLang(payload) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.SET_MASTER_LANG,
      payload: payload,
    });
  };
}

export function setfactUpdate(payload) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.SET_FACT_UPDATE,
      payload: payload,
    });
  };
}
